
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"15","height":"32","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"stroke":"#E4E4E4","stroke-width":"2","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M14 8.756l-6.562-7L1 8.624"}}),_c('path',{attrs:{"d":"M7.5 4.256v26.505","stroke-linecap":"square"}})])])
      }
    
      }
    